import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './TimePicker.scss';
import { injectIntl } from 'react-intl';
import * as moment from 'moment';
import classNames from 'classnames';
import ArrowUpIcon from 'assets/icons/enter.svg';
import AddIcon from 'assets/icons/add-icon.svg';
import MinusIcon from 'assets/icons/minus-icon.svg';

class TimePicker extends Component {
  static propTypes = {
    /** Time (moment) */
    time: PropTypes.objectOf(PropTypes.any),
    /** Submit time */
    onSubmit: PropTypes.func,
    /** is RTL */
    rtl: PropTypes.bool,
  };

  static defaultProps = {
    time: moment('090000', 'HHmmss'),
    onSubmit: () => {},
    rtl: false,
  };

  constructor(props) {
    super(props);

    this.state = {
      time: this.props.time,
    };
  }

  onTimeUp = () => {
    if (this.state.time < moment('190000', 'HHmmss')) {
      this.setState(prevState => ({
        time: prevState.time.add(60, 'm'),
      }));
    }
  }

  onTimeDown = () => {
    if (this.state.time > moment('090000', 'HHmmss')) {
      this.setState(prevState => ({
        time: prevState.time.subtract(60, 'm'),
      }));
    }
  }

  handleTimeSubmit = () => {
    this.props.onSubmit(`${this.state.time.format('hh:mm A')}`, { toTranslate: false });
  }

  render() {
    const classes = classNames({
      'nw-time-picker': true,
      'nw-time-picker--rtl': this.props.rtl,
    });
    return (
      <footer className={classes}>

        <div className="nw-time-picker__fieldset">
          <button type="button" className="nw-button nw-button--icon" onClick={this.onTimeDown}>
            <img src={MinusIcon} alt="Subtract" />
          </button>
          <input
            type="text"
            value={this.state.time.format('hh:mm A')}
            readOnly
          />
          <button
            type="button"
            className="nw-button nw-button--icon"
            onClick={this.onTimeUp}
          >
            <img src={AddIcon} alt="Add" />
          </button>
        </div>

        <button type="button" className="nw-button nw-button--icon nw-button--submit" onClick={this.handleTimeSubmit}>
          <img src={ArrowUpIcon} alt="Submit" />
        </button>
      </footer>
    );
  }
}


export default injectIntl(TimePicker);
